import * as _ from 'lodash';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import ESDataTableWithHeader from 'src/common/ESDataTableWithHeader';
import IDataTableManager from 'src/common/IDataTableManager';
import { DefaultUser, IUser } from 'src/Definitions';
import { SimpleEntityDto } from 'src/generated_client';
import { IStores } from 'src/Stores';

interface IUsersProps {
    currentOrganization?: SimpleEntityDto;
    currentUser?: IUser;
    dataTableManager?: IDataTableManager<IUser>;
    getColumnSettingsAndUsers?: () => void;
    getOrganizations?: (pageNumber?: number, pageSize?: number) => void;
    getRoles?: (pageNumber?: number, pageSize?: number) => void;
    isAdmin?: boolean;
    isLoading?: boolean;
    isModalOpen?: boolean;
    openDialogWithUser?: (user: IUser) => void;
}

@inject((stores: IStores) => ({
    currentOrganization: stores.global.currentOrganization,
    currentUser: stores.global.user,
    dataTableManager: stores.users.dataTableStore,
    getColumnSettingsAndUsers: stores.users.getColumnSettingsAndUsers,
    getOrganizations: stores.organizations.getAllOrganizations,
    getRoles: stores.roles.getAllRoles,
    isAdmin: stores.global.isAdmin,
    isLoading: stores.users.isLoading,
    isModalOpen: stores.users.isModalOpen,
    openDialogWithUser: stores.users.openDialogWithUser,
}))
@observer
class Users extends React.Component<IUsersProps> {
    public componentDidMount() {
        this.props.getOrganizations!(undefined, 5000);

        this.props.getRoles!(undefined, 5000);
        this.props.getColumnSettingsAndUsers!();
    }

    public openDialog = (user: IUser) => () => {
        const { isAdmin, currentOrganization } = this.props;
        if (!isAdmin && currentOrganization) {
            user.organization = currentOrganization;
            user.organizationId = currentOrganization.id!;
        }
        this.props.openDialogWithUser!(user);
    };

    public render() {
        return (
            <ESDataTableWithHeader
                dataTableManager={this.props.dataTableManager!}
                enableEdit={true}
                enableReorderColumns={true}
                enableSearch={true}
                enableShowInactives={true}
                enableToggleColumns={true}
                openDialog={this.openDialog(DefaultUser(true))}
                title="Users"
            />
        );
    }
}

export default Users;



// WEBPACK FOOTER //
// ./src/users/Users.tsx